"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyOverrides = applyOverrides;

var _env = require("./env.js");

var _overridesByPathname = require("./overridesByPathname.js");

var _mergeObjects = require("./mergeObjects.js");

function applyOverrides(args, scope) {
  var _config$data;

  var config = (0, _overridesByPathname.getCurrentOverrides)();

  if (!config) {
    if (typeof window === 'object') {
      if (_env._outsmartly_dev_mode) {
        console.warn("[Outsmartly SDK] missing entry for component ".concat(scope, ". This is only expected when OUTSMARTLY_DEV=true mode is enabled and you're viewing your site without the Outsmartly Edge in front of it."));
      } else {
        console.error("[Outsmartly SDK] missing entry for component ".concat(scope, ". Usually this means you're viewing the site without the Outsmartly Edge."));
      }
    }

    return args;
  }

  if (config.isLoading) {
    console.error("[Outsmartly SDK] component ".concat(scope, " was rendered while its overrides were still loading."));
    return args;
  }

  var override = (_config$data = config.data) === null || _config$data === void 0 ? void 0 : _config$data.overrides[scope];

  if (!override) {
    return args;
  }

  var overriddenProps = JSON.parse(override).props; // When override React component's we only care about the
  // first argument, the props. The babel output is still an
  // array for future-proofing.

  (0, _mergeObjects.mergeObjects)(overriddenProps, args[0]);
  return [overriddenProps];
}